

export const DealTable = {
    id: 'DealTable',
    title: 'DealTable',
    showCheckboxes: false,
    pdf:false,    
    items: [
        { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo', width: '400px'},
        // { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width: '50px'},
        // { id: 'size', title: 'Размер', formatter: 'ProductSize', width: '100px' },
        // { id: 'size.techTask', title: 'Техническое задание', formatter: 'ShowTechTaskButton', width: '350px'},
        { id: 'tz', title: 'Техническое задание', formatter: 'AdminTechTaskButton', width: '350px'},
        { id: 'data', title: 'Штрих код', formatter: "barCodeFormat", width: '220px'}, 
        { id: 'countAllProduct', title: 'Кол-во', formatter: 'ProductAllCount', width: '0px'},
        { id: 'qrcode', title: 'QR код', formatter: "qrCodeFormat", width: '70px'},
        // { id: 'qrCount', title: 'Кол-во QR', formatter: 'DefaultTypography', width: '80px'},
        { id: 'data.dimensions', title: 'Объем', formatter: 'ProductDim', width: '100px'},
        { id: 'size.fulf_size', title: 'Объем фф', formatter: 'ProductDimEditable', width: '100px'},
        // { id: 'package', title: 'Упаковка', formatter: 'PackageTagsInfo', width: '170px'},
        // { id: 'packageFeatures', title: 'Особенности упаковки', formatter: 'PackageFeatures', width: '0px'},
        { id: 'inbox', title: 'Входит в короб', formatter: 'DefaultTypography', width: '100px'},
        // { id: 'tags', title: 'Этикетки', formatter: 'PackageTagsInfo', width: '0px'}

        ],
    details: true,
    showDetails: (obj) => {
      console.log('showDetails', obj);
    }
  };

  
  export const DealTableFBSWB = {
    id: 'DealTableFBSWB',
    title: 'DealTableFBSWB',
    showCheckboxes: false,
    pdf:false,    
    items: [
        { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo', width: '400px'},
        { id: 'tz', title: 'Техническое задание', formatter: 'AdminTechTaskButton', width: '350px'},
        { id: 'data', title: 'Штрих код', formatter: "barCodeFormat", width: '220px'}, 
        { id: 'countAllProduct', title: 'Кол-во', formatter: 'ProductAllCount', width: '0px'},
        { id: 'fbsStatus', title: 'Кол-во', formatter: 'fbsStatus'},
        { id: 'qrcode', title: 'QR код', formatter: "qrCodeFormat", width: '70px'},
        { id: 'data.dimensions', title: 'Объем', formatter: 'ProductDim', width: '100px'},
        { id: 'size.fulf_size', title: 'Объем фф', formatter: 'ProductDimEditable', width: '100px'},
        { id: 'inbox', title: 'Входит в короб', formatter: 'DefaultTypography', width: '100px'},

        ],
    details: true,
    showDetails: (obj) => {
      console.log('showDetails', obj);
    }
  };

export const ReturnsTable = {
  id: 'ReturnsTable',
  title: 'Возвраты',
  api:'productsClientBridge',
  showCheckboxes: false,
  expanded:false,  
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo', width: '350px' },
    // { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width: '50px'},
    // { id: 'size.title', title: 'Размер', formatter: 'DefaultTypography'},
    // { id: 'size.barcode', title: 'Баркод', formatter: 'DefaultTypography'},
    { id: 'count', title: 'Всего', formatter: 'ProductCountAll', width:'80px' },
    { id: 'countDefect', title: 'Брак', formatter: 'ProductCountDefect', width:'80px' },
    { id: 'countSelfRet', title: 'Самовыкуп', formatter: 'ProductCountSelfRet', width:'80px' }
  ]
};

export const ReturnsTableModern = {
  id: 'ReturnsTableModern',
  title: 'Возвраты',
  api:'productsClientBridge',
  showCheckboxes: false,
  expanded:false,  
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo', width: '400px' },
    { id: 'count', title: 'Всего', formatter: 'ProductCountAll', width:'80px' },
  ]
};

export const ClientsDefects = {
  id: 'ClientsDefects',
  title: 'Брак',
  api:'productsClientBridge',
  showCheckboxes: false,
  expanded:false,  
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo' , sortable: true, width: '400px'},
    { id: 'countProduct', title: 'Кол-во', formatter: 'DefaultTypographyShort', width:'80px' },
    // { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width: '50px'},
    // { id: 'size.title', title: 'Размер', formatter: 'DefaultTypography'},
    // { id: 'size.barcode', title: 'Баркод', formatter: 'DefaultTypography'},
  ]
};

export const ClientsReturns = {
  id: 'ClientsReturns',
  title: 'Возврат',
  api:'productsClientBridge',
  showCheckboxes: false,
  expanded:false,  
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo' , sortable: true, width: '400px'},
    { id: 'countProduct', title: 'Кол-во', formatter: 'DefaultTypographyShort', width:'80px' },
    // { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width: '50px'},
    // { id: 'size.title', title: 'Размер', formatter: 'DefaultTypography'},
    // { id: 'size.barcode', title: 'Баркод', formatter: 'DefaultTypography'},
  ]
};

export const DealTableConsume = {
    id: 'DealTableConsume',
    title: 'DealTableConsume',
    showCheckboxes: false,
    pdf:false,    
    items: [
        { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo', width: '400px'},
        { id: 'countAllProduct', title: 'Кол-во', formatter: 'ProductAllCount'},
        { id: 'data.dimensions', title: 'Объем', formatter: 'ProductDim', width: '120px'},
        { id: 'data', title: 'Штрих код', formatter: "barCodeFormat", width: '220px'}, 
        { id: 'qrcode', title: 'QR код', formatter: "qrCodeFormat", width: '70px'},
        { id: 'inbox', title: 'Входит в короб', formatter: 'DefaultTypography'},

        ],
    details: true,
    showDetails: (obj) => {
      console.log('showDetails', obj);
    }
  };


export const DealTableForClient = {
    id: 'DealTableForClient',
    title: 'DealTableForClient',
    showCheckboxes: false,
    pdf:false,    
    items: [
        { id: 'data', title: 'Товар', formatter: 'Product', width: '290px' },
        { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width: '50px'},
        { id: 'size', title: 'Размер', formatter: 'ProductSize', width: '120px' },
        { id: 'data.dimensions', title: 'Объем', formatter: 'ProductDim', width: '100px'},
        { id: 'size.techTask', title: 'Техническое задание', formatter: 'ShowTechTaskButton', width: '350px'},
        { id: 'data', title: 'Штрих код', formatter: "BarCode", width: '200px'}, 
        { id: 'countAllProduct', title: 'Кол-во', formatter: 'ProductAllCount', width: '120px'},
        { id: 'qrcode', title: 'QR код', formatter: "qrCodeFormatNoPrint", width:'50px'},
        // { id: 'qrCount', title: 'Кол-во QR', formatter: 'DefaultTypography', width: '80px'},
        // { id: 'qrcode', title:' Кол-во распечатанных QR', formatter: 'PrintedQrCount'},
        // { id: 'package', title: 'Упаковка', formatter: 'PackageTagsInfo', width: '170px'},
        // { id: 'packageFeatures', title: 'Особенности упаковки', formatter: 'PackageFeatures', width: '0px'},
        { id: 'inbox', title: 'Входит в короб', formatter: 'DefaultTypography', width: '100px'},
        // { id: 'tags', title: 'Этикетки', formatter: 'PackageTagsInfo', width: '0px'}
        ],
    details: false,
  };

export const DealTableForClientConsum = {
    id: 'DealTableForClientConsum',
    title: 'DealTableForClientConsum',
    showCheckboxes: false,
    pdf:false,    
    items: [
        { id: 'data', title: 'Товар', formatter: 'Consumable', width: '290px' },
        { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width: '50px'},
        { id: 'size', title: 'Размер', formatter: 'ProductSize', width: '120px' },
        { id: 'data.dimensions', title: 'Объем', formatter: 'ProductDim', width: '100px'},,
        { id: 'data', title: 'Штрих код', formatter: "BarCode", width: '200px'}, 
        { id: 'countAllProduct', title: 'Кол-во', formatter: 'ProductAllCount', width: '120px'},
        // { id: 'qrcode', title: 'QR код', formatter: "qrCodeFormat"},
        { id: 'qrCount', title: 'Кол-во QR', formatter: 'DefaultTypography', width: '80px'},
        { id: 'package', title: 'Упаковка', formatter: 'PackageTagsInfo', width: '170px'},
        { id: 'packageFeatures', title: 'Особенности упаковки', formatter: 'PackageFeatures', width: '0px'},
        { id: 'inbox', title: 'Входит в короб', formatter: 'DefaultTypography', width: '100px'},
        // { id: 'tags', title: 'Этикетки', formatter: 'PackageTagsInfo', width: '0px'}
        ],
    details: false,
  };

export const BindProducts = {
  id: 'BindProducts',
  api: 'marketsBridge',
  title: 'Добавить товары в короб',
  showCheckboxes: false,
  items: [
    // { id: 'data', title: 'Товар', formatter: 'Product' },
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo' , sortable: true, width: '350px'},
    // { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort'},
    // { id: 'data.barcode', title: 'Штрих код', formatter: 'DefaultTypography'}, //МЕНЯТЬ
    // { id: 'size', title: 'Размер', formatter: 'ProductSize' },
    // { id: 'data.color', title: 'Цвет', formatter: 'ColorsList'},
    { id: 'countProduct', title: 'Кол-во', formatter: 'ProductCountEdit' },
  ],
};

export const BindProductsBlocked = {
  id: 'BindProductsBlocked',
  api: 'marketsBridge',
  title: 'Добавить товары в короб',
  showCheckboxes: false,
  items: [
    // { id: 'data', title: 'Товар', formatter: 'Product' },
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo' , sortable: true, width: '350px'},
    // { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort'},
    // { id: 'data.barcode', title: 'Штрих код', formatter: 'DefaultTypography'}, //МЕНЯТЬ
    // { id: 'size', title: 'Размер', formatter: 'ProductSize' },
    // { id: 'data.color', title: 'Цвет', formatter: 'ColorsList'},
    { id: 'countProduct', title: 'Кол-во', formatter: 'DefaultTypography' },
  ],
};


export const BindProductsClient = {
  id: 'BindProductsClient',
  api: 'marketsBridge',
  title: 'Добавить товары в короб',
  showCheckboxes: false,
  items: [
    { id: 'data', title: 'Товар', formatter: 'Product', sortable: true },
    { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', sortable: true},
    { id: 'size', title: 'Размер', formatter: 'ProductSize' },
    { id: 'data.barcode', title: 'Штрих код', formatter: 'DefaultTypography'}, //МЕНЯТЬ
    { id: 'data.color', title: 'Цвет', formatter: 'ColorsList'},
    { id: 'countProduct', title: 'Кол-во', formatter: 'DefaultTypography' , sortable: true},
  ],
};

//todo доработать использование одного дескриптора в другом
export const BindProductsSelected = {
  id: 'BindProductsSelected',
  api: 'marketsBridge',
  title: 'Добавить товары в короб',
  showCheckboxes: true,
  items: [
    { id: 'data', title: 'Товар', formatter: 'Product', sortable: true },
    { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', sortable: true},
    { id: 'size', title: 'Размер', formatter: 'ProductSize'},
    { id: 'data.barcode', title: 'Штрих код', formatter: 'DefaultTypography'}, //МЕНЯТЬ
    { id: 'data.color', title: 'Цвет', formatter: 'ColorsList'},
    { id: 'countProduct', title: 'Кол-во', formatter: 'ProductCountEdit', sortable: true },
  ],
};

export const BindProductsSelectedFloat = {
  id: 'BindProductsSelectedFloat',
  api: 'marketsBridge',
  title: 'Добавить товары в короб',
  showCheckboxes: true,
  items: [
    { id: 'data', title: 'Товар', formatter: 'Product', sortable: true },
    { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', sortable: true},
    { id: 'size', title: 'Размер', formatter: 'ProductSize'},
    { id: 'data.barcode', title: 'Штрих код', formatter: 'DefaultTypography'}, //МЕНЯТЬ
    { id: 'data.color', title: 'Цвет', formatter: 'ColorsList'},
    { id: 'countProduct', title: 'Кол-во', formatter: 'ProductCountEditFloat', sortable: true },
  ],
};

export const CopyProductsSelected = {
  id: 'CopyProductsSelected',
  api: 'marketsBridge',
  title: 'Копировать поле в товары',
  showCheckboxes: true,
  items: [
    { id: 'data', title: 'Товар', formatter: 'Product' },
    { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort'},
    { id: 'size', title: 'Размер', formatter: 'ProductSize' },
    { id: 'data.color', title: 'Цвет', formatter: 'ColorsList'}
  ],
};

export const NotBindProducts = {
  id: 'NotBindProducts',
  api: 'marketsBridge',
  title: 'Добавить товары в короб',
  showCheckboxes: false,
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo' , sortable: true, width: '350px'},
    // { id: 'data', title: 'Информация', formatter: 'HowMoveInfo', width:'200px'},
    { id: 'countProduct', title: 'Количество', formatter: 'BigDisignNumber', sortable: true, width: '100px'},
  ],
};

export const multiWayDelivery = {
  id: 'multiWayDelivery',
  api: 'marketsBridge',
  title: 'multiWayDelivery',
  showCheckboxes: false,
  items: [
    { id: 'warehouse', title: 'Склад', formatter: 'DefaultTypography'},
    { id: 'barcode', title: 'Баркод', formatter: 'DefaultTypography'},
    { id: 'showCount', title: 'Кол-во', formatter: 'MultiWayDelivery'},
  ],
};

export const multiWayDeliveryBC = {
  id: 'multiWayDeliveryBC',
  api: 'marketsBridge',
  title: 'multiWayDeliveryBC',
  showCheckboxes: false,
  items: [
    { id: 'warehouse', title: 'Склад', formatter: 'DefaultTypography' },
    { id: 'countBox', title: 'Коробов', formatter: 'DefaultTypography'},
    { id: 'count', title: 'Товаров', formatter: 'DefaultTypography'},
  ],
};

export const DealPay = {
  id: 'DealPay',
  api: 'defBridge',
  title: 'Оплата услуг',
  showCheckboxes: false,
  items: [
    { id: 'service', title: 'Услуга', formatter: 'DefaultTypography' },
    { id: 'price', title: 'Стоимость', formatter: 'DefaultTypography'},
    { id: 'count', title: 'Количество', formatter: 'DefaultTypography'},
    { id: 'sum', title: 'Итого', formatter: 'DefaultTypography'}
    // { id: 'status', title: 'Статус оплаты', formatter: "StatusPayChanged" },
  ],
};

export const DealPayClient = {
  id: 'DealPayClient',
  api: 'defBridge',
  title: 'Оплата услуг',
  showCheckboxes: false,
  items: [
    { id: 'service', title: 'Услуга', formatter: 'DefaultTypography' },
    { id: 'price', title: 'Стоимость', formatter: 'DefaultTypography'},
    // { id: 'status', title: 'Статус оплаты', formatter: "StatusPay" },
  ],
};

export const fbsAdmin = {
  id: 'fbsAdmin',
  api: 'defBridge',
  title: 'fbs',
  showCheckboxes: true,
  items: [
    // { id: 'user', title: 'Клиент', formatter: 'UserShort', width: '120px', sortable:true },
    { id: 'shortUser', title: 'Клиент', formatter: 'DefaultTypography ', width: '120px', sortable:true },
    { id: 'data.title', title: 'Товар', formatter: 'DefaultTypography', width: '200px', sortable:true },
    { id: 'data.size', title: 'Размер', formatter: 'ProductSize', width: '120px', sortable:true },
    { id: 'data.size.barcode', title: 'Баркод', formatter: 'DefaultTypography', width: '120px', sortable:true },
  ],
};

export const fbsAdminWB = {
  id: 'fbsAdminWB',
  api: 'defBridge',
  title: 'fbs',
  showCheckboxes: true,
  items: [
    { id: 'data', title: 'Клиент', formatter: 'ProductMoreInfo', width: '350px', sortable:true },
    { id: 'shortUser', title: 'Клиент', formatter: 'DefaultTypography ', width: '120px', sortable:true },
    { id: 'createdAt', title: 'Дата создания', formatter: 'FBSDateWB', width: '60px', sortable:true },    
    { id: 'warehouseWB.name', title: 'Склад WB', formatter: 'DefaultTypography', width: '100px', sortable:true },
    { id: 'warehouseCLI.name', title: 'Склад продавца', formatter: 'DefaultTypography', width: '100px', sortable:true }
  ],
};

export const fbsAdminOZON = {
  id: 'fbsAdminOZON',
  api: 'defBridge',
  title: 'fbs',
  showCheckboxes: true,
  items: [
    { id: 'data', title: 'Клиент', formatter: 'ProductMoreInfo', width: '350px', sortable:true },
    { id: 'shortUser', title: 'Клиент', formatter: 'DefaultTypography ', width: '120px', sortable:true },
    { id: 'posting_number', title: '№ заказа', formatter: 'DefaultTypography ', width: '120px', sortable:true },
    // { id: 'createdAt', title: 'Дата создания', formatter: 'FBSDateWB', width: '60px', sortable:true },    
    { id: 'warehouseOZON.name', title: 'Склад OZON', formatter: 'DefaultTypography', width: '200px', sortable:true },
    { id: 'warehouseCLI.name', title: 'Пунтк назначения', formatter: 'DefaultTypography', width: '200px', sortable:true }
  ],
};



export const fbsAdminOpenWB = {
  id: 'fbsAdminOpenWB',
  api: 'defBridge',
  title: 'FBS',
  details: true,
  additionalOrientation: 'row',
  items: [
    { id: 'data.cdn', title: '№' , width: '50px' },
    { id: 'user', title: 'Клиент', formatter: 'UserShort', width: '120px' },
    { id: 'createdAt', title: 'Дата создания', formatter:"date" , width: '150px'},
    { id: 'includes_products', title: 'Товары', formatter: "DealProductsAllInfoFBS", width: '250px'},
    { id: 'dealDetails', title: 'Детали', formatter: "DealDetails"},
    { id: 'FBSstatus', title: 'Статус', formatter: "FBSDealStatus"},
  ]
};

export const fbsAdminOpen = {
  id: 'fbsAdminOpen',
  api: 'defBridge',
  title: 'FBS',
  details: true,
  additionalOrientation: 'row',
  items: [
    { id: 'data.cdn', title: '№' , width: '50px' },
    { id: 'user', title: 'Клиент', formatter: 'UserShort', width: '120px' },
    { id: 'createdAt', title: 'Дата создания', formatter:"date" , width: '150px'},
    { id: 'includes_products', title: 'Товары', formatter: "DealProductsAllInfoFBS", width: '250px'},
    { id: 'dealDetails', title: 'Детали', formatter: "DealDetails"},
  ]
};